//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const moment = require("moment-timezone");
import SuccessDialogPushpaymentIM from "@/components/cards/SuccessDialogPushpaymentIM";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import api from "@/services/api";
import {
  server,
  imageappointmentTMUrl,
  fileappointmentTMUrl,
} from "@/services/constants";
import pdfvuer from "pdfvuer";

export default {
  name: "AppoinmrntPatentOperation",

  components: {
    SuccessDialog,
    SuccessDialogPush,
    SuccessDialogPushpaymentIM,
    pdf: pdfvuer,
  },
  data() {
    return {
      uploadedFiles: {},
      existingFiles: {},
      oldFiles: {},
      oldFilesCheck: {},
      uploadedFilesDoctype: {},
      menuaddAppD: false,
      check_closed: true,
      dialogCheckbox: false,
      checkboxes: {
        Form001: false,
        Descriptions: false,
        Claims: false,
        Drawings: false,
        Abstract: false,
      },
      checkboxFields: {
        Form001: "Form 001ก",
        Descriptions: "Descriptions",
        Claims: "Claims",
        Drawings: "Drawings",
        Abstract: "Abstract",
      },
      querydata: {},
      dataappiontment: {},
      isShowPassword: false,
      fullPage: true,
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      objecttype_list: [],
      menuReceive: false,
      menuFilling: false,
      menuStart: false,
      menuaddlapd: false,
      menuDeadline: false,
      sourcetypelist: ["Electronic Notice", "Physical Paper Notice", "EMail"],
      category_ptlist: [
        "New Application",
        "Office Action",
        "Publication Fee",
        "Publication",
        "Substantive Examination",
        "Publication Fee & Registration Fee",
        "Publication Fee & Registration Fee & Annuity Fee",
        "Registration Fee",
        "Registration Fee & Annuity Fee",
        "Certificate",
        "Annuity Fee",
      ],
      doctype_actions_select: [],
      doctype_actions_select_old: [],
      doctype_actions_tlist: [],
      typelist: [
        { type_name: "Design", type_number: "1" },
        { type_name: "Invention", type_number: "2" },
        { type_name: "Petty", type_number: "3" },
        { type_name: "Invention/PCT", type_number: "4" },
      ],
      documenttype_ptlist: [],
      documenttype_ptlist_search: [],
      app_noshow: "",
      typeshow: 0,
      titleshow: "",
      receive_date: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      filling_date: null,
      startdate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      enddate: null,
      date_of_application: null,
      internaldate: null,
      itemdata: {
        date_of_application: null,
        last_annuity_paid: null,
        next_annuity_date: null,
        final_due_date_for_next_payment: null,
        dead_last_annuity_paid: "",
        app_no: "",
        objecttype: 0,
        doctype: 0,
        trademark_name: "",
        refno: "",
        categories: "",
        filling_date: null,
        receive_date: this.formatDate(
          new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10)
        ),
        startdate: this.formatDate(
          new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10)
        ),
        enddate: null,
        internaldate: this.formatDate(
          new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10)
        ),
        sourcetype: "",
        description: "",
        remark: "",
        report: false,
        paymentrequest: false,
        cert: false,
        nextdeadlineninety: false,
        nextdeadlinesixty: false,
        done: false,
        closed: 1,
      },
      getpreview_listnotice: [],
      preview_listnotice: [],
      image_listnotice: [],
      filenamenotice: [],
      preview_listnotice2: [],
      preview_listattach: [],
      preview_listrecicpt: [],
      image_listattach: [],
      image_listrecicpt: [],
      image_listrecicpt_old: [],
      filenameattach: [],
      filenamerecive: [],
      getpreview_listattach: [],
      getpreview_listreceipt: [],
      preview_listattach2: [],
      preview_listrecipt2: [],
      previewpopupfile: [],
      previewpopupfile2: [],
      checkfileapreview: false,
      dialogpreviewfilenotice: false,
      page: 1,
      numPages: 0,
      numPagespreview: 0,
      numPagespreviewattach: 0,
      pdfdata: undefined,
      errors: [],
      scale: "page-width",
      previewpopupattachfile2: [],
      previewpopupattachfile: [],
      checkattachfileapreview: false,
      dialogpreviewattachfile: false,
      previewattachimage: "",
      dialogpreviewattachimage: false,
      dialogconfirmdeletenoticefile: false,
      dialogconfirmdeleteattachfile: false,
      dialogconfirmdeleteattrecipt: false,
      indexdeleteattachfile: -1,
      indexdeleteattreciept: -1,
      indexdeleteattachfilelist: -1,
      customer_id_forpatmentrequest: 0,
      showAnn: false,
      showAnnReg: false,
      showAnnfirst: false,
      showChage: false,
      showNew: false,
      latest_list: [
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
      ],
      menuaddnewfilling: false,
      menuaddnad: false,
      menuaddnadfinalDatePayment: false,
      new_filling: false,
      data_maserter_pt: [],
      data_maserter_pt_priority: [],
      default_col: true,
      default_type: true,
      last_annuity_paid: null,
      next_annuity_date: null,
      final_due_date_for_next_payment: null,
      associate_contact_name: "",
      agent_contact_name: "",
      contact_agent_list: [],
      contact_associate_list: [],
      contact_owner_list: [],
      changeMasterRecord: {
        type: false,
        title: false,
        titleInThai: false,
        clientName: false,
        agentReference: false,
        agentName: false,
        associateName: false,
      },
      showSub: false,
      showNewFilingExact: false,
      showNewFilingSubdoc: false,
      statuslist: [
        { status_name: "Pending", status_value: 1 },
        { status_name: "Completed", status_value: 2 },
        { status_name: "Close", status_value: 3 },
        { status_name: "Payment Request", status_value: 4 },
      ],
      reportlist: [
        { report_name: "Not Reported", report_value: 0 },
        { report_name: "Reported – Pending Invoice", report_value: 1 },
        { report_name: "Invoiced", report_value: 2 },
        { report_name: "Reported & Invoiced", report_value: 3 },
      ],
    };
  },
  async mounted() {
    await api.checkVersion();
    await this.loaddatafile_no();
    await this.loaddataobjecttypeBygroupId();
    await this.loaddatadocumentPTtype();

    if (this.app_noshow !== "" && this.itemdata.refno !== "") {
      // --------------- check data in ocr table ----------------
      let ocr_data = await api.checkAppointmentOCR(
        this.app_noshow,
        this.itemdata.refno
      );

      if (ocr_data.data !== null) {
        let map_data = await api.mapKeyWordPT(
          this.app_noshow,
          this.itemdata.refno
        );
        this.itemdata.doctype = map_data.data.doctype_id;
      } else {
      }

      // --------------- check data in map table ----------------
    }
    await this.loadDataDotypeAction();
    this.prev_doctype_actions_select = [...this.doctype_actions_select];
    await this.loaddatacontactByContact_type_owner();
    await this.loaddatacontactByContact_type_agent();
    await this.loaddatacontactByContact_type_associate();

    await this.loaddataApp();
    await this.loadreceiptfile();
    await this.loadSoftfile();
    await this.loadChageRC();

    this.$hideLoader();
  },
  methods: {
    async onAppNoBlur() {
      var check_appno = await api.getAppNpCheck({
        params: {
          id: this.data_maserter_pt.masterpt_id,
          app_no: this.itemdata.app_no,
        },
      });
      if (check_appno.status == 203) {
        this.itemdata.app_no = this.data_maserter_pt.app_no;
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "data duplicate ",
          "please check Application No.",
          "text-h5 red--text text-center"
        );
        return;
      }
    },
    handleFileUpload(event, key) {
      const files = Array.from(event.target.files);

      // เก็บชื่อไฟล์ทั้งหมดที่มีอยู่ใน uploadedFiles ทุก key
      const allUploadedNames = Object.values(this.uploadedFiles)
        .flat()
        .map((f) => f.name);

      // รวมชื่อไฟล์เก่าจาก oldFiles ทุก key
      const oldFileNames = Object.values(this.oldFiles || {}).flat();

      if (!this.uploadedFiles[key]) {
        this.$set(this.uploadedFiles, key, []);
      }

      files.forEach((file) => {
        let newName = file.name;
        let baseName = newName;
        let ext = "";

        // แยกนามสกุลไฟล์ (.docx, .doc ฯลฯ)
        const dotIndex = newName.lastIndexOf(".");
        if (dotIndex !== -1) {
          baseName = newName.substring(0, dotIndex);
          ext = newName.substring(dotIndex);
        }

        let counter = 1;
        // ตรวจสอบชื่อไฟล์ซ้ำทั้งใน uploadedFiles และ oldFiles
        while (
          allUploadedNames.includes(newName) ||
          oldFileNames.includes(newName)
        ) {
          newName = `${baseName}-${counter}${ext}`;
          counter++;
        }

        // สร้างไฟล์ใหม่ clone พร้อมชื่อใหม่
        const renamedFile = new File([file], newName, { type: file.type });

        // เพิ่มชื่อใหม่เข้า allUploadedNames เพื่อกันชื่อซ้ำกับไฟล์ถัดไป
        allUploadedNames.push(newName);

        // เพิ่มไฟล์ลงใน uploadedFiles
        this.uploadedFiles[key].push(renamedFile);
      });
    },

    removeUploadedFile(key, index) {
      this.uploadedFiles[key].splice(index, 1);
    },
    removeExistingFile(key, index) {
      if (!this.existingFiles[key]) return;

      // clone existingFiles object ทั้งหมด
      const newExistingFiles = { ...this.existingFiles };

      // clone array ของ key นั้น แล้วลบ element index ออก
      newExistingFiles[key] = [...newExistingFiles[key]];
      newExistingFiles[key].splice(index, 1);

      // อัพเดต reactive ด้วยการแทนที่ตัวใหม่ทั้ง object
      this.existingFiles = newExistingFiles;

      // ถ้ามี oldFiles ที่เก็บชื่อไฟล์ก็ทำแบบเดียวกัน
      if (this.oldFiles && this.oldFiles[key]) {
        const newOldFiles = { ...this.oldFiles };
        newOldFiles[key] = [...newOldFiles[key]];
        newOldFiles[key].splice(index, 1);
        this.oldFiles = newOldFiles;
      }

      // ปิด checkbox ถ้าไฟล์หมด
      if (newExistingFiles[key].length === 0) {
        this.checkboxes = { ...this.checkboxes, [key]: false };
      }
    },

    updateFinalDueDateFromNextAnnuity() {
      var dateString = this.next_annuity_date;

      if (!dateString) return "";

      const [year, month, day] = dateString.split("-").map(Number);
      const date = new Date(year, month - 1, day); // สร้าง Date

      if (this.showAnnfirst) {
        date.setDate(date.getDate() + 59); // บวก 60 วัน
      } else {
        date.setDate(date.getDate() + 60);
      }

      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");

      this.itemdata.final_due_date_for_next_payment = `${d}/${m}/${y}`;
    },
    async loaddatacontactByContact_type_owner() {
      const result = await api.getContactByContactType(1);
      this.contact_owner_list = result.data;
    },
    async loaddatacontactByContact_type_associate() {
      const result = await api.getContactByContactType(3);
      this.contact_associate_list = result.data;
    },
    async loaddatacontactByContact_type_agent() {
      const result = await api.getContactByContactType(2);
      this.contact_agent_list = result.data;
    },
    chageobjecttype() {
      if (this.itemdata.objecttype != 0) {
        const matchedDoc = this.documenttype_ptlist.filter(
          (item) => item.objecttype_id == this.itemdata.objecttype
        );

        this.documenttype_ptlist_search = matchedDoc;
        const exists = this.documenttype_ptlist_search.some(
          (item) => item.documenttype_id === this.itemdata.doctype
        );
        if (!exists) {
          this.itemdata.doctype = 0;
        }
      }
    },
    async loadChageRC() {
      const res_crc = await api.getCHAGE_MASTER_RECORD_BYID(
        this.$route.params.appointment_id
      );

      if (
        this.showChage &&
        Array.isArray(res_crc.data) &&
        res_crc.data.length > 0
      ) {
        // สร้าง object ที่แมทกับ changeMasterRecord
        const mappedData = res_crc.data.reduce((acc, item) => {
          acc[item.field_name] = item.status === true;
          return acc;
        }, {});

        // อัปเดตค่าใน changeMasterRecord ทีละ field ถ้ามี key ตรงกัน
        for (const key in this.changeMasterRecord) {
          if (mappedData.hasOwnProperty(key)) {
            this.changeMasterRecord[key] = mappedData[key];
          }
        }
      }
    },

    async loaddataApp() {
      if (this.$route.params.appointment_id) {
        this.appointment_id = this.$route.params.appointment_id;
        this.FlieArray = [];
        this.image_listnotice = [];
        this.image_listattach = [];
        this.filenamenotice = [];

        var data_search = {
          tbl_name1: "appointment_attachment_files",
          tbl_name2: "appointment_notice_file",
          tbl_id: Number(this.appointment_id),
        };

        const result_file = await api.getAllFileAtLawFileAp({
          params: data_search,
        });

        if (result_file.data.length > 0) {
          this.oldnotifile = [];
          this.oldnotiimage = [];
          this.oldattfile = [];
          this.oldattimage = [];

          this.FlieArray = result_file.data;

          for (const [index, item] of result_file.data.entries()) {
            if (item.tbl_name == "appointment_notice_file") {
              if (item.file_type == "file") {
                this.image_listnotice.push(`${item.file_name}`);
                this.filenamenotice.push(item.file_name);
                this.oldnotifile.push(item.file_name);
              } else {
                this.image_listnotice.push(`${item.file_name}`);
                this.filenamenotice.push(item.file_name);
                this.oldnotiimage.push(item.file_name);
              }
            } else {
              var data = {
                name: item.file_name,
              };

              if (item.file_type == "file") {
                this.oldattfile.push(data);
              } else {
                this.oldattimage.push(data);
              }

              this.image_listattach.push(data);
            }
          }
        }

        const resultappointment = await api.AppointmentgetById(
          this.appointment_id
        );

        const res_doc = this.documenttype_ptlist.find(
          (item) => item.documenttype_id === resultappointment.data[0].doctype
        );

        const result = await api.getfile_noPT(resultappointment.data[0].refno);
        //set ann env
        // this.data_maserter_pt = result.data[0];
        this.data_maserter_pt.dead_last_annuity_paid_pt =
          resultappointment.data[0].dead_last_annuity_paid;
        this.data_maserter_pt.last_annuity_paid_pt =
          resultappointment.data[0].last_annuity_paid;
        this.data_maserter_pt.next_annuity_date_pt =
          resultappointment.data[0].next_annuity_date;
        this.data_maserter_pt.final_due_date_for_next_payment_pt =
          resultappointment.data[0].final_due_date_for_next_payment;

        //set New Filing env

        const res_priority = await api.getAllMASTERPT_PRIORITY_BYID(
          Number(result.data[0].masterpt_id)
        );
        this.data_maserter_pt_priority = res_priority.data;

        if (res_doc && res_doc.documenttype_code) {
          const type_check_an =
            res_doc.documenttype_code.includes("Annuity Fees");
          if (type_check_an) {
            this.default_col = false;
            this.showAnn = true;
            this.itemdata.dead_last_annuity_paid =
              resultappointment.data[0].dead_last_annuity_paid;
            this.itemdata.last_annuity_paid = this.formatDate(
              resultappointment.data[0].last_annuity_paid
            );
            this.itemdata.next_annuity_date = this.formatDate(
              resultappointment.data[0].next_annuity_date
            );
            this.itemdata.final_due_date_for_next_payment = this.formatDate(
              resultappointment.data[0].final_due_date_for_next_payment
            );
            if (res_doc.documenttype_code === "Registration & Annuity Fees") {
              this.showAnnReg = true;
              this.default_col = true;
              this.itemdata.receive_date =
                resultappointment.data[0].receive_date == "0000-00-00"
                  ? null
                  : resultappointment.data[0].receive_date;
              this.itemdata.startdate = resultappointment.data[0].startdate;
              this.itemdata.enddate = resultappointment.data[0].enddate;
              this.itemdata.filling_date =
                resultappointment.data[0].filling_date;
              this.itemdata.internaldate =
                resultappointment.data[0].internaldate == "0000-00-00"
                  ? null
                  : resultappointment.data[0].internaldate;
            } else {
              this.showAnnfirst = true;
            }
          } else {
            this.data_maserter_pt = result.data[0];
          }

          const type_check_new =
            res_doc.documenttype_code.includes("New Filing");
          if (type_check_new) {
            this.showNew = true;
            this.itemdata.new_filling = this.formatDate(
              resultappointment.data[0].new_filling
            );
            if (res_doc.documenttype_code === "New Filing") {
              this.default_col = false;
              this.showNewFilingExact = true;
              this.showNewFilingSubdoc = false;
              this.itemdata.app_no = this.data_maserter_pt.app_no;
              this.itemdata.date_of_application = this.formatDate(
                this.data_maserter_pt.date_of_application
              );
              this.date_of_application =
                this.data_maserter_pt.date_of_application;
            } else if (res_doc.documenttype_code === "New Filing Sub Doc") {
              this.default_col = true;
              this.showNewFilingSubdoc = true;
              this.showNewFilingExact = false;
            } else {
              this.showNewFilingExact = false;
              return;
            }
          }

          const type_check_changeMasterRecord =
            res_doc.documenttype_code.includes("Change Master of Record");
          if (type_check_changeMasterRecord) {
            this.showAnn = false;
            this.showNew = false;
            this.default_col = false;
            this.default_type = false;
            this.showChage = true;
          }

          const type_check_sub = res_doc.documenttype_code.includes(
            "Substantive Examination"
          );
          if (type_check_sub) {
            this.showSub = true;
          }

          // let rawIds = resultappointment.data[0].documenttype_action_id;
          // let ids = [];

          // if (rawIds) {
          //   ids = rawIds.split(",").map(id => parseInt(id.trim(), 10));
          // }

          // this.doctype_actions_select = ids;
        }

        if (!resultappointment.data[0].documenttype_action_id) {
          var dataSearch = {
            appointment_type: "Patent",
            appointment_id: this.$route.params.appointment_id,
          };

          var res_doctype_action =
            await api.getAllAppointmentDoctypeActionsBYID({
              params: dataSearch,
            });

          if (res_doctype_action.data.length > 0) {
            this.doctype_actions_select = res_doctype_action.data.map(
              (item) => item.documenttype_action_id
            );
            this.doctype_actions_select_old = this.doctype_actions_select;
          } else {
            this.doctype_actions_select = []; // กำหนดค่า default ว่าง ๆ
            this.doctype_actions_select_old = [];
          }
        }

        this.itemdata.refno = resultappointment.data[0].refno.toUpperCase();
        this.itemdata.objecttype = resultappointment.data[0].objecttype;
        this.itemdata.receive_date =
          resultappointment.data[0].receive_date == "0000-00-00"
            ? new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                .toISOString()
                .substr(0, 10)
            : resultappointment.data[0].receive_date;
        this.itemdata.startdate = resultappointment.data[0].startdate;
        this.itemdata.enddate = resultappointment.data[0].enddate;
        this.itemdata.filling_date = resultappointment.data[0].filling_date;
        this.itemdata.internaldate =
          resultappointment.data[0].internaldate == "0000-00-00"
            ? new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                .toISOString()
                .substr(0, 10)
            : resultappointment.data[0].internaldate;
        this.itemdata.doctype = resultappointment.data[0].doctype;
        this.itemdata.categories = resultappointment.data[0].categories;
        this.itemdata.description = resultappointment.data[0].description;
        this.itemdata.remark = resultappointment.data[0].remark;
        this.itemdata.nextdeadlineninety =
          resultappointment.data[0].nextdeadlineninety;
        this.itemdata.nextdeadlinesixty =
          resultappointment.data[0].nextdeadlinesixty;
        this.itemdata.report = resultappointment.data[0].report;
        this.itemdata.paymentrequest = resultappointment.data[0].paymentrequest;
        this.itemdata.cert = resultappointment.data[0].cert;
        this.itemdata.done = resultappointment.data[0].done;
        this.itemdata.closed = resultappointment.data[0].closed;
        this.itemdata.sourcetype = resultappointment.data[0].sourcetype;
        if (
          this.itemdata.refno != "" &&
          this.itemdata.refno != " " &&
          this.itemdata.refno != ""
        ) {
          // this.onSearchfile_nosave(this.itemdata.refno);
          const resultf = await api.getfile_noPT(this.itemdata.refno);
          this.titleshow = resultf.data[0].title;
          this.app_noshow = resultf.data[0].app_no;
          this.typeshow = resultf.data[0].type;
          this.customer_id_forpatmentrequest =
            resultf.data[0].agent_contact_custid != 0
              ? resultf.data[0].agent_contact_custid
              : resultf.data[0].owner_contact_custid != 0
              ? resultf.data[0].owner_contact_custid
              : 0;
        }
        this.itemdata.receive_date = this.formatDate(
          this.itemdata.receive_date
        );
        this.itemdata.startdate = this.formatDate(this.itemdata.startdate);
        this.itemdata.enddate = this.formatDate(this.itemdata.enddate);
        this.itemdata.filling_date = this.formatDate(
          this.itemdata.filling_date
        );
        this.itemdata.internaldate = this.formatDate(
          this.itemdata.internaldate
        );

        if (
          resultappointment.data[0].notice_file &&
          resultappointment.data[0].notice_file != ""
        ) {
          this.oldnotifile = [];
          this.oldnotiimage = [];

          //เซต table file
          let masterFile = resultappointment.data[0].notice_file;

          // แยกค่าด้วยเครื่องหมายคอมม่า
          let fileArray = masterFile.split(",");

          // ตัดช่องว่างที่หน้าและหลังของแต่ละค่า
          fileArray = fileArray.map((image) => image.trim());

          // ถ้าคุณต้องการลบคอมม่าที่ท้ายสุด ถ้ามี
          if (fileArray[fileArray.length - 1] === "") {
            fileArray.pop(); // ลบค่าว่างที่เกิดจากคอมม่าที่ท้ายสุด
          }
          if (fileArray.length > 0) {
            for (const [index, item] of fileArray.entries()) {
              var data_tablefile = {
                id: 0,
                tbl_name: "appointment_notice_file",
                tbl_id: this.appointment_id,
                file_type: "",
                file_name: item,
                created_at: "",
                updated_at: "",
                update_date: "-",
              };
              if (item.split(".").pop().toLowerCase() == "pdf") {
                data_tablefile.file_type = "file";
                this.oldnotifile.push(item);
              } else {
                data_tablefile.file_type = "image";
                this.oldnotiimage.push(item);
              }
              this.FlieArray.push(data_tablefile);
              this.filenamenotice.push(item);
              this.image_listnotice.push(item);
            }
          }
          //   this.oldnotifile = this.getpreview_listnotice;
        }
        if (
          resultappointment.data[0].attachment_files &&
          resultappointment.data[0].attachment_files != ""
        ) {
          this.oldattfile = [];
          this.oldattimage = [];

          let masterImages = resultappointment.data[0].attachment_files;

          // แยกค่าด้วยเครื่องหมายคอมม่า
          let imageArray = masterImages.split(",");

          // ตัดช่องว่างที่หน้าและหลังของแต่ละค่า
          imageArray = imageArray.map((image) => image.trim());

          // ถ้าคุณต้องการลบคอมม่าที่ท้ายสุด ถ้ามี
          if (imageArray[imageArray.length - 1] === "") {
            imageArray.pop(); // ลบค่าว่างที่เกิดจากคอมม่าที่ท้ายสุด
          }

          if (imageArray.length > 0) {
            for (const [index, item] of imageArray.entries()) {
              var data_tableimage = {
                id: 0,
                tbl_name: "appointment_attachment_files",
                tbl_id: this.appointment_id,
                file_type: "",
                file_name: item,
                created_at: "",
                updated_at: "",
                update_date: "-",
              };
              if (item.split(".").pop().toLowerCase() == "pdf") {
                data_tableimage.file_type = "file";
                this.oldattfile.push({ name: item });
              } else {
                data_tableimage.file_type = "image";
                this.oldattimage.push({ name: item });
              }

              this.FlieArray.push(data_tableimage);
              this.image_listattach.push({ name: item });
            }
          }
        }

        if (
          resultappointment.data[0].owner_contact &&
          resultappointment.data[0].owner_contact != ""
        ) {
          this.itemdata.owner_contact = resultappointment.data[0].owner_contact;
          var ownername = resultappointment.data[0].owner_contact;

          var listid_owner = ownername.split(",").map((s) => Number(s.trim()));

          const matchedContactsOwner = this.contact_owner_list.filter(
            (contact) => listid_owner.includes(contact.contact_id)
          );

          this.itemdata.trademark_name = "";
          this.itemdata.trademark_name = matchedContactsOwner
            .map((c) => c.contact_name)
            .join(", ");
        } else {
          this.itemdata.trademark_name = "";
          this.itemdata.owner_contact = "";
        }

        if (
          resultappointment.data[0].agent_contact &&
          resultappointment.data[0].agent_contact != 0
        ) {
          this.itemdata.agent_contact = resultappointment.data[0].agent_contact;

          this.contact_agent_list.filter((item) => {
            if (item.contact_id == this.itemdata.agent_contact) {
              this.agent_contact_name = item.contact_name;
            }
          });
        } else {
          this.agent_contact_name = "";
          this.itemdata.agent_contact = 0;
        }

        if (
          resultappointment.data[0].associate_contact &&
          resultappointment.data[0].associate_contact != 0
        ) {
          this.itemdata.associate_contact =
            resultappointment.data[0].associate_contact;
          this.contact_associate_list.filter((item) => {
            if (item.contact_id == this.itemdata.associate_contact) {
              this.associate_contact_name = item.contact_name;
            }
          });
        } else {
          this.associate_contact_name = "";
          this.itemdata.associate_contact = 0;
        }

        if (Number(this.itemdata.closed) != 3) {
          this.check_closed = true;
        } else {
          this.check_closed = false;
        }
      }
    },
    async loadreceiptfile() {
      var data_search_rc = {
        tbl_name1: "appointment_receipt_files",
        tbl_name2: "appointment_receipt_image",
        tbl_id: Number(this.appointment_id),
      };

      const result_rcfile = await api.getAllFileAtLawFileAp({
        params: data_search_rc,
      });

      this.filenamerecive = [];
      this.image_listrecicpt = [];
      if (result_rcfile.data.length > 0) {
        for (const [index, item] of result_rcfile.data.entries()) {
          this.filenamerecive.push(item.file_name);

          var datarc = {
            name: item.file_name,
          };
          this.image_listrecicpt.push(datarc);
          this.image_listrecicpt_old.push(datarc);
        }
      }
    },
    async loadSoftfile() {
      this.checkboxes = {
        Form001: false,
        Descriptions: false,
        Claims: false,
        Drawings: false,
        Abstract: false,
      };

      this.existingFiles = {}; // เก็บไฟล์เก่า
      this.uploadedFiles = {}; // ไฟล์ใหม่
      this.oldFiles = {}; // เก็บชื่อไฟล์เก่าแบบสั้น
      this.oldFilesCheck = {}; // เก็บชื่อไฟล์เก่าแบบสั้น

      const softfileTypes = [
        { key: "Form001", tbl_name: "appointment_softfile_form001" },
        { key: "Descriptions", tbl_name: "appointment_softfile_descriptions" },
        { key: "Claims", tbl_name: "appointment_softfile_claims" },
        { key: "Drawings", tbl_name: "appointment_softfile_drawings" },
        { key: "Abstract", tbl_name: "appointment_softfile_abstract" },
      ];

      for (const type of softfileTypes) {
        const params = {
          tbl_name: type.tbl_name,
          tbl_id: Number(this.appointment_id),
        };

        try {
          const response = await api.getAllFileAtLawFile({ params });

          if (
            response &&
            Array.isArray(response.data) &&
            response.data.length > 0
          ) {
            this.checkboxes[type.key] = true;

            // เก็บข้อมูลไฟล์เก่าทั้งหมด (เป็น array)
            this.existingFiles[type.key] = response.data.map((file) => ({
              name: file.file_name,
              previewUrl: `${fileappointmentTMUrl}/${this.$route.params.appointment_id}/${file.file_name}`,
            }));

            // เก็บเฉพาะชื่อไฟล์ (สำหรับส่งกลับ)
            this.oldFiles[type.key] = response.data.map(
              (file) => file.file_name
            );
            this.oldFilesCheck[type.key] = response.data.map(
              (file) => file.file_name
            );
          }
        } catch (error) {
          console.error(`Error loading ${type.tbl_name}:`, error);
        }
      }
    },

    calDateAnn() {
      this.itemdata.next_annuity_date = this.formatDate(
        this.data_maserter_pt.next_annuity_date_pt
      );

      const cal_y =
        Number(this.itemdata.dead_last_annuity_paid) -
        Number(this.data_maserter_pt.dead_last_annuity_paid_pt);

      if (cal_y !== 0) {
        // แปลง next_annuity_date จาก dd/mm/yyyy → Date
        const [day, month, year] = this.itemdata.next_annuity_date
          .split("/")
          .map(Number);
        const nextDate = new Date(year, month - 1, day);

        // เพิ่ม/ลดปีตาม cal_y
        nextDate.setFullYear(nextDate.getFullYear() + cal_y);

        // กำหนดค่ากลับให้ next_annuity_date
        const updatedNextDate = `${nextDate.getFullYear()}-${String(
          nextDate.getMonth() + 1
        ).padStart(2, "0")}-${String(nextDate.getDate()).padStart(2, "0")}`;
        this.itemdata.next_annuity_date = this.formatDate(updatedNextDate);

        // คำนวณ final_due_date โดยบวก 60 วัน
        const finalDue = new Date(nextDate);
        if (this.showAnnfirst) {
          finalDue.setDate(finalDue.getDate() + 59);
        } else {
          finalDue.setDate(finalDue.getDate() + 60);
        }

        const d = String(finalDue.getDate()).padStart(2, "0");
        const m = String(finalDue.getMonth() + 1).padStart(2, "0");
        const y = finalDue.getFullYear();

        this.itemdata.final_due_date_for_next_payment = `${d}/${m}/${y}`;
      } else {
        // ไม่ต้องคำนวณใหม่ ใช้ค่าจาก master
        this.itemdata.next_annuity_date = this.formatDate(
          this.data_maserter_pt.next_annuity_date_pt
        );
        this.itemdata.final_due_date_for_next_payment = this.formatDate(
          this.data_maserter_pt.final_due_date_for_next_payment_pt
        );
      }

      this.$forceUpdate();
    },
    fileDoctypeInput() {
      // หาว่า id ไหนถูกลบออก
      const removed = this.prev_doctype_actions_select.filter(
        (id) => !this.doctype_actions_select.includes(id)
      );

      // ลบไฟล์ที่เกี่ยวข้อง
      removed.forEach((id) => {
        this.$delete(this.uploadedFilesDoctype, id);
      });

      // อัปเดตค่าก่อนหน้า
      this.prev_doctype_actions_select = [...this.doctype_actions_select];
    },
    async loadDataDotypeAction() {
      const res_doctye_actions = await api.getbyobjectgroup_id(2);
      this.doctype_actions_tlist = res_doctye_actions.data;
    },
    triggerFileInput(key) {
      this.$refs[`fileInput_${key}`][0].click();
    },

    triggerFileInputDoctype(itemId) {
      this.$refs[`fileInput_${itemId}`][0].click();
    },
    handleFileUploadDoctype(event, itemId) {
      const file = event.target.files[0];
      if (file) {
        this.$set(this.uploadedFilesDoctype, itemId, file);
      }
    },
    cancelCheckbox() {
      this.dialogCheckbox = false;
      this.checkboxes = {
        Form001: false,
        Descriptions: false,
        Claims: false,
        Drawings: false,
        Abstract: false,
      };
      this.uploadedFiles = {};
      this.checkboxes = {
        Form001: false,
        Descriptions: false,
        Claims: false,
        Drawings: false,
        Abstract: false,
      };
    },
    saveSelection() {
      this.dialogCheckbox = false;
    },
    openselectFileWorld() {
      this.dialogCheckbox = true;
    },
    async previewMultiFile(event) {
      // ถ้าอยากล้างไฟล์เดิม uncomment ข้างล่าง
      // this.preview_listnotice = [];
      // this.image_listnotice = [];
      // this.filenamenotice = [];

      const input = event.target;
      if (!input.files || input.files.length === 0) {
        return;
      }

      const files = Array.from(input.files);

      files.forEach((file) => {
        if (file.type === "application/pdf" || file.type.startsWith("image/")) {
          let originalName = file.name;
          let name = originalName;
          let counter = 1;

          const existingNames = this.filenamenotice;

          // ถ้าชื่อซ้ำ ให้เพิ่ม _1, _2, _3
          while (existingNames.includes(name)) {
            const dotIndex = originalName.lastIndexOf(".");
            if (dotIndex !== -1) {
              const basename = originalName.substring(0, dotIndex);
              const extension = originalName.substring(dotIndex);
              name = `${basename}-${counter}${extension}`;
            } else {
              name = `${originalName}-${counter}`;
            }
            counter++;
          }

          // สร้างไฟล์ใหม่ชื่อไม่ซ้ำ
          const renamedFile = new File([file], name, { type: file.type });

          // preview
          const reader = new FileReader();
          reader.onload = (e) => {
            this.preview_listnotice.push(e.target.result);
          };
          reader.readAsDataURL(renamedFile);

          // เก็บไฟล์และชื่อ
          this.image_listnotice.push(renamedFile);
          this.filenamenotice.push(name);
        }
      });

      this.checkfilenotice = true;
    },
    async previewnoticefilepdf(index) {
      var checkfile = this.image_listnotice[index];

      if (checkfile.type) {
        if (checkfile.type == "application/pdf") {
          const reader = new FileReader();
          reader.onload = (e) => {
            const checkfile = e.target.result;

            let pdf_newTab = window.open("");
            pdf_newTab.document.write(`
              <html>
                <head>
                  <title>PDF Preview</title>
                  <style>
                    html, body {
                      margin: 0;
                      height: 100%;
                      overflow: hidden;
                    }
                    iframe {
                      border: none;
                      width: 100%;
                      height: 100%;
                    }
                  </style>
                </head>
                <body>
                  <iframe src="${checkfile}" title="PDF Preview"></iframe>
                </body>
              </html>
            `);
            pdf_newTab.document.close();
          };
          reader.readAsDataURL(checkfile);
          return;
        } else {
          const reader = new FileReader();
          reader.onload = (e) => {
            const checkfile = e.target.result;

            let pdf_newTab = window.open("");
            pdf_newTab.document.write(`
               <html>
                <head>
                  <title>Image Preview</title>
                  <style>
                    html, body {
                      margin: 50px 0 0 0;
                      height: 80%;
                      overflow: hidden;
                      background-color: black;
                      display: flex;
                      justify-content: center; /* จัดกลางในแนวนอน */
                      align-items: center; /* จัดกลางในแนวตั้ง */
                    }
                    img {
                      width: 100%;
                      height: 100%;
                      object-fit: contain; /* รูปภาพจะไม่ยืดออก */
                    }
                  </style>
                </head>
                <body>
                  <img src="${checkfile}" title="Image Preview" />
                </body>
              </html>
            `);
            pdf_newTab.document.close();
          };
          reader.readAsDataURL(checkfile);
          return;
        }
      } else {
        if (checkfile.split(/[\s.]+/).pop() == "pdf") {
          let pdf_newTab = window.open("");
          pdf_newTab.document.write(
            `
              <html>
                <head>
                  <title>PDF Preview</title>
                  <style>
                    html, body {
                      margin: 0;
                      height: 100%;
                      overflow: hidden;
                    }
                    iframe {
                      border: none;
                      width: 100%;
                      height: 100%;
                    }
                  </style>
                </head>
                <body>
                  <iframe src="${fileappointmentTMUrl}/${this.$route.params.appointment_id}/${checkfile}" title="PDF Preview"></iframe>
                </body>
              </html>
            `
          );
          return;
        } else {
          const imageTab = window.open("");
          imageTab.document.write(`
            <html>
              <head>
                <title>Preview Image</title>
              </head>
              <body style="margin:0; display:flex; flex-direction:column; justify-content:center; align-items:center; height:100vh; background-color:#000;">
                <!-- แสดงภาพที่นี่ -->
                <img src="${imageappointmentTMUrl}/${this.$route.params.appointment_id}/${checkfile}" alt="Preview" style="max-width:100%; max-height:100%; margin-bottom:20px;" />
                
              </body>
            </html>
          `);
          return;
        }
      }
    },
    async closepreviewfile() {
      this.dialogpreviewfilenotice = false;
    },
    async getPdfforpreview(datafile) {
      this.previewpopupfile = [];
      let getfile = "";
      getfile = datafile;
      this.previewpopupfile.push(pdfvuer.createLoadingTask(`${getfile}`));
      this.previewpopupfile.forEach((item, index) => {
        item.then((pdf) => {
          this.numPagespreview = pdf.numPages;
        });
      });
    },
    async confirmdeletenoticefile(index) {
      this.indexdeleteattachfilelist = index;
      this.dialogconfirmdeletenoticefile = true;
    },
    async closedialogconfirmdeletenoticefile() {
      this.dialogconfirmdeletenoticefile = false;
    },
    async deletedialogconfirmdeletenoticefile() {
      this.getpreview_listnotice.splice(this.indexdeleteattachfilelist, 1);
      this.preview_listnotice.splice(this.indexdeleteattachfilelist, 1);
      this.image_listnotice.splice(this.indexdeleteattachfilelist, 1);
      this.filenamenotice.splice(this.indexdeleteattachfilelist, 1);
      this.dialogconfirmdeletenoticefile = false;
    },
    async deletedialogconfirmdeleteattachfile() {
      this.filenameattach.splice(this.indexdeleteattachfile, 1);
      this.preview_listattach.splice(this.indexdeleteattachfile, 1);
      this.image_listattach.splice(this.indexdeleteattachfile, 1);
      this.getpreview_listattach.splice(this.indexdeleteattachfile, 1);
      this.dialogconfirmdeleteattachfile = false;
    },
    async deletedialogconfirmdeletereceipt() {
      this.filenamerecive.splice(this.indexdeleteattreciept, 1);
      this.getpreview_listreceipt.splice(this.indexdeleteattreciept, 1);
      this.preview_listrecicpt.splice(this.indexdeleteattreciept, 1);
      this.image_listrecicpt.splice(this.indexdeleteattreciept, 1);
      this.dialogconfirmdeleteattrecipt = false;
    },
    async previewMultiAttachFile(event) {
      // ❗ ถ้าอยากลบไฟล์เดิมที่เคยอัปโหลด ให้เคลียร์ array
      // this.preview_listattach = [];
      // this.getpreview_listattach = [];
      // this.image_listattach = [];
      this.filenameattach = [];

      const input = event.target;
      if (!input.files || input.files.length === 0) {
        return;
      }

      const files = Array.from(input.files);

      files.forEach((file) => {
        // เฉพาะ PDF และรูปภาพ
        if (file.type === "application/pdf" || file.type.startsWith("image/")) {
          let originalName = file.name;
          let name = originalName;
          let counter = 1;

          // รวมชื่อไฟล์ที่มีอยู่แล้วใน image_listattach
          const existingNames = this.image_listattach.map((f) => f.name);

          // ถ้าซ้ำ ให้เพิ่ม _1, _2, ...
          while (existingNames.includes(name)) {
            const dotIndex = originalName.lastIndexOf(".");
            if (dotIndex !== -1) {
              const basename = originalName.substring(0, dotIndex);
              const extension = originalName.substring(dotIndex);
              name = `${basename}-${counter}${extension}`;
            } else {
              name = `${originalName}-${counter}`;
            }
            counter++;
          }

          // สร้างไฟล์ใหม่ชื่อไม่ซ้ำ
          const renamedFile = new File([file], name, { type: file.type });

          // preview
          const reader = new FileReader();
          reader.onload = (e) => {
            this.getpreview_listattach.push(e.target.result);
            this.preview_listattach.push(e.target.result);
          };
          reader.readAsDataURL(renamedFile);

          // เก็บไฟล์และชื่อ
          this.image_listattach.push(renamedFile);
          this.filenameattach.push(name);
        }
      });

      this.preview_listattach2 = this.preview_listattach;
      this.checkfileattach = true;
    },
    async previewMultiReceipt(event) {
      this.filenamerecive = [];

      const input = event.target;
      if (!input.files || input.files.length === 0) {
        return;
      }

      const files = Array.from(input.files);

      files.forEach((file) => {
        // เฉพาะ PDF และรูปภาพ
        if (file.type === "application/pdf" || file.type.startsWith("image/")) {
          let originalName = file.name;
          let name = originalName;
          let counter = 1;

          // ตรวจสอบชื่อซ้ำใน image_listrecicpt
          const existingNames = this.image_listrecicpt.map((f) => f.name);

          // ถ้าชื่อซ้ำให้เพิ่ม -1, -2, ...
          while (existingNames.includes(name)) {
            const dotIndex = originalName.lastIndexOf(".");
            if (dotIndex !== -1) {
              const basename = originalName.substring(0, dotIndex);
              const extension = originalName.substring(dotIndex);
              name = `${basename}-${counter}${extension}`;
            } else {
              name = `${originalName}-${counter}`;
            }
            counter++;
          }

          // สร้างไฟล์ใหม่ชื่อไม่ซ้ำ
          const renamedFile = new File([file], name, { type: file.type });

          // Preview
          const reader = new FileReader();
          reader.onload = (e) => {
            this.getpreview_listreceipt.push(e.target.result);
            this.preview_listrecicpt.push(e.target.result);
          };
          reader.readAsDataURL(renamedFile);

          // เก็บไฟล์และชื่อ
          this.image_listrecicpt.push(renamedFile);
          this.filenamerecive.push(name);
        }
      });

      this.preview_listrecipt2 = this.preview_listrecicpt;
      this.checkfileattach = true;
    },

    async previewattachfile(index) {
      let checkfile = this.image_listattach[index];
      if (checkfile.type) {
        if (checkfile.type == "application/pdf") {
          const reader = new FileReader();
          reader.onload = (e) => {
            const checkfile = e.target.result;

            let pdf_newTab = window.open("");
            pdf_newTab.document.write(`
              <html>
                <head>
                  <title>PDF Preview</title>
                  <style>
                    html, body {
                      margin: 0;
                      height: 100%;
                      overflow: hidden;
                    }
                    iframe {
                      border: none;
                      width: 100%;
                      height: 100%;
                    }
                  </style>
                </head>
                <body>
                  <iframe src="${checkfile}" title="PDF Preview"></iframe>
                </body>
              </html>
            `);
            pdf_newTab.document.close();
          };
          reader.readAsDataURL(checkfile);
          return;
        } else {
          const reader = new FileReader();
          reader.onload = (e) => {
            const checkfile = e.target.result;

            let pdf_newTab = window.open("");
            pdf_newTab.document.write(`
               <html>
                <head>
                  <title>Image Preview</title>
                  <style>
                    html, body {
                      margin: 50px 0 0 0;
                      height: 80%;
                      overflow: hidden;
                      background-color: black;
                      display: flex;
                      justify-content: center; /* จัดกลางในแนวนอน */
                      align-items: center; /* จัดกลางในแนวตั้ง */
                    }
                    img {
                      width: 100%;
                      height: 100%;
                      object-fit: contain; /* รูปภาพจะไม่ยืดออก */
                    }
                  </style>
                </head>
                <body>
                  <img src="${checkfile}" title="Image Preview" />
                </body>
              </html>
            `);
            pdf_newTab.document.close();
          };
          reader.readAsDataURL(checkfile);
          return;
        }
      } else {
        if (this.image_listattach[index].name.split(/[\s.]+/).pop() == "pdf") {
          window.open(
            `${fileappointmentTMUrl}/${this.$route.params.appointment_id}/${this.image_listattach[index].name}`
          );
          return;
        } else {
          const imageTab = window.open("");
          imageTab.document.write(`
            <html>
              <head>
                <title>Preview Image</title>
              </head>
              <body style="margin:0; display:flex; flex-direction:column; justify-content:center; align-items:center; height:100vh; background-color:#000;">
                <img src="${imageappointmentTMUrl}/${this.$route.params.appointment_id}/${this.image_listattach[index].name}" alt="Preview" style="max-width:100%; max-height:100%; margin-bottom:20px;" />
              </body>
            </html>
          `);
          return;
        }
      }
    },
    async previewreceiptfile(index) {
      let checkfile = this.image_listrecicpt[index];
      if (checkfile.type) {
        const fileUrl = URL.createObjectURL(checkfile);
        const extension = checkfile.name.split(".").pop().toLowerCase();

        if (extension === "pdf") {
          const pdfWindow = window.open("", "_blank");
          pdfWindow.document.write(`
    <html>
      <head>
        <title>PDF Preview</title>
        <style>
          html, body {
            margin: 0;
            height: 100%;
          }
          iframe {
            border: none;
            width: 100%;
            height: 100%;
          }
        </style>
      </head>
      <body>
        <iframe src="${fileUrl}"></iframe>
      </body>
    </html>
  `);
        } else {
          const imgWindow = window.open("", "_blank");
          imgWindow.document.write(`
    <html>
      <head><title>Image Preview</title></head>
      <body style="margin:0; display:flex; justify-content:center; align-items:center; background:#000; height:100vh;">
        <img src="${fileUrl}" style="max-width:100%; max-height:100%;" />
      </body>
    </html>
  `);
        }
      } else {
        if (checkfile.name.split(/[\s.]+/).pop() == "pdf") {
          window.open(
            `${fileappointmentTMUrl}/${this.$route.params.appointment_id}/${checkfile.name}`
          );
          return;
        } else {
          const imageTab = window.open("");
          imageTab.document.write(`
                    <html>
                    <head>
                        <title>Preview Image</title>
                    </head>
                    <body style="margin:0; display:flex; flex-direction:column; justify-content:center; align-items:center; height:100vh; background-color:#000;">
                        <img src="${imageappointmentTMUrl}/${this.$route.params.appointment_id}/${checkfile.name}" alt="Preview" style="max-width:100%; max-height:100%; margin-bottom:20px;" />
                    </body>
                    </html>
                `);
          return;
        }
      }
    },
    async getPforpreviewattach(datafile) {
      this.previewpopupattachfile = [];
      let getfile = "";
      getfile = datafile;
      this.previewpopupattachfile.push(pdfvuer.createLoadingTask(`${getfile}`));
      this.previewpopupattachfile.forEach((item, index) => {
        item.then((pdf) => {
          this.numPagespreviewattach = pdf.numPages;
        });
      });
    },
    async closepreviewattachfile() {
      this.dialogpreviewattachfile = false;
    },
    async closepreviewattachimage() {
      this.dialogpreviewattachimage = false;
    },
    async confirmdeleteattachfile(index) {
      this.indexdeleteattachfile = index;
      this.dialogconfirmdeleteattachfile = true;
    },
    async confirmdeleteattreceipt(index) {
      this.indexdeleteattreciept = index;
      this.dialogconfirmdeleteattrecipt = true;
    },
    async closepreviewreceipt(index) {
      this.indexdeleteattreciept = -1;
      this.dialogconfirmdeleteattrecipt = false;
    },
    async closedialogconfirmdeleteattachfile() {
      this.indexdeleteattachfile = -1;
      this.dialogconfirmdeleteattachfile = false;
    },

    async loaddatafile_no() {
      if (this.$route.params.file_no) {
        this.itemdata.refno = this.$route.params.file_no;
        this.onSearchfile_no(this.itemdata.refno);
      }
    },
    async loaddataobjecttypeBygroupId() {
      const result = await api.getObjectTypeByGroupId(2);
      this.objecttype_list = result.data;
    },
    async loaddatadocumentPTtype() {
      const result = await api.getdocumenttype_ptcode();
      this.documenttype_ptlist = result.data;
      this.documenttype_ptlist_search = result.data;
    },
    async onSearchfile_no(file_no) {
      if (!file_no || file_no.trim() == "") {
        this.itemdata.objecttype = 0;
        this.itemdata.refno = "";
        this.app_noshow = "";
        this.titleshow = "";
        this.itemdata.trademark_name = "";
        this.typeshow = 0;
        return;
      }
      this.itemdata.refno = this.itemdata.refno.trim().toUpperCase();
      this.changeMasterRecord = {
        type: false,
        title: false,
        titleInThai: false,
        clientName: false,
        agentReference: false,
        agentName: false,
        associateName: false,
      };
      this.trademark_name = "";
      this.agent_contact_name = "";
      this.associate_contact_name = "";
      const result = await api.getfile_noPT(file_no);

      if (result.data[0]) {
        this.data_maserter_pt = result.data[0];
        const res_priority = await api.getAllMASTERPT_PRIORITY_BYID(
          Number(result.data[0].masterpt_id)
        );
        this.data_maserter_pt_priority = res_priority.data;

        this.titleshow = result.data[0].title;
        this.itemdata.objecttype = result.data[0].tm_type;
        this.app_noshow = result.data[0].app_no;
        this.itemdata.trademark_name = result.data[0].name_of_client;
        this.typeshow = result.data[0].type;
        this.customer_id_forpatmentrequest =
          result.data[0].agent_contact_custid != 0
            ? result.data[0].agent_contact_custid
            : result.data[0].owner_contact_custid != 0
            ? result.data[0].owner_contact_custid
            : 0;

        if (
          result.data[0].owner_contact_id &&
          result.data[0].owner_contact_id != ""
        ) {
          this.itemdata.owner_contact = result.data[0].owner_contact_id;
          var ownername = result.data[0].owner_contact_id;
          var listid_owner = ownername.split(",").map((s) => Number(s.trim()));
          const matchedContactsOwner = this.contact_owner_list.filter(
            (contact) => listid_owner.includes(contact.contact_id)
          );
          this.itemdata.trademark_name = "";
          this.itemdata.trademark_name = matchedContactsOwner
            .map((c) => c.contact_name)
            .join(", ");
        } else {
          this.itemdata.trademark_name = "";
        }
        if (
          result.data[0].agent_contact_id &&
          result.data[0].agent_contact_id != 0
        ) {
          this.itemdata.agent_contact = result.data[0].agent_contact_id;

          this.contact_agent_list.filter((item) => {
            if (item.contact_id == this.itemdata.agent_contact) {
              this.agent_contact_name = item.contact_name;
            }
          });
        } else {
          this.agent_contact_name = "";
        }

        if (
          result.data[0].associate_contact_id &&
          result.data[0].associate_contact_id != 0
        ) {
          this.itemdata.associate_contact = result.data[0].associate_contact_id;
          this.contact_associate_list.filter((item) => {
            if (item.contact_id == this.itemdata.associate_contact) {
              this.associate_contact_name = item.contact_name;
            }
          });
        } else {
          this.associate_contact_name = "";
        }
        this.checktypeFunction();
      } else {
        this.data_maserter_pt = [];
        this.itemdata.objecttype = 0;
        this.itemdata.refno = "";
        this.app_noshow = "";
        this.titleshow = "";
        this.itemdata.trademark_name = "";
        this.typeshow = 0;
        this.customer_id_forpatmentrequest = 0;
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Search File No. ",
          "File No. not found ",
          "text-h5 red--text text-center"
        );
        return;
      }
    },
    async onSearchfile_nosave(file_no) {
      if (!file_no || file_no.trim() == "") {
        this.itemdata.refno = "";
        this.app_noshow = "";
        this.titleshow = "";
        this.itemdata.trademark_name = "";
        this.typeshow = 0;
        return;
      }
      //alert(file_no);
      const result = await api.getfile_noPT(file_no);
      if (result.data[0]) {
        //alert("hevedata");
        this.titleshow = result.data[0].title;
        this.app_noshow = result.data[0].app_no;
        this.itemdata.trademark_name = result.data[0].name_of_client;
        this.typeshow = result.data[0].type;
        this.customer_id_forpatmentrequest =
          result.data[0].agent_contact_custid != 0
            ? result.data[0].agent_contact_custid
            : result.data[0].owner_contact_custid != 0
            ? result.data[0].owner_contact_custid
            : 0;
      } else {
        this.itemdata.refno = "";
        this.app_noshow = "";
        this.titleshow = "";
        this.itemdata.trademark_name = "";
        this.typeshow = 0;
        this.customer_id_forpatmentrequest = 0;
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Search File No. ",
          "File No. not found ",
          "text-h5 red--text text-center"
        );
        return;
      }
    },
    checktypeFunction() {
      if (this.itemdata.doctype == 0) return;

      const doctype = this.documenttype_ptlist.find(
        (item) => item.documenttype_id === this.itemdata.doctype
      );
      if (!doctype) return;

      const code = doctype.documenttype_code;

      const isAnnuity = code.includes("Annuity Fees");
      const isRegistration = code === "Registration & Annuity Fees";

      const isNewFiling = code.includes("New Filing");
      const isNewFilingExact = code === "New Filing";
      const isNewFilingSubDoc = code === "New Filing Sub Doc";

      const isChangeMaster = code.includes("Change Master of Record");
      const isSubstantiveExam = code.includes("Substantive Examination");

      // Default: reset flags
      this.default_col = !isAnnuity && !isNewFiling && !isChangeMaster;
      this.showAnn = false;
      this.showAnnReg = false;
      this.showAnnfirst = false;
      this.showNew = false;
      this.showNewFilingExact = false;
      this.showNewFilingSubdoc = false;
      this.showChage = false;
      this.showSub = false;

      // Clear fields
      this.itemdata.dead_last_annuity_paid = "";
      this.itemdata.last_annuity_paid = null;
      this.itemdata.next_annuity_date = null;
      this.itemdata.new_filling = null;
      this.itemdata.internaldate = null;
      this.itemdata.receive_date = this.formatDate(
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10)
      );
      this.receive_date = this.changeformatDatetoinsert(
        this.itemdata.receive_date
      );
      // this.itemdata.date_of_application = null;

      this.changeMasterRecord = {
        type: false,
        title: false,
        titleInThai: false,
        clientName: false,
        agentReference: false,
        agentName: false,
        associateName: false,
      };

      if (isAnnuity) {
        this.default_col = false;
        this.showAnn = true;
        if (this.data_maserter_pt) {
          this.itemdata.dead_last_annuity_paid =
            this.data_maserter_pt.dead_last_annuity_paid_pt;
          this.itemdata.last_annuity_paid = this.formatDate(
            this.data_maserter_pt.last_annuity_paid_pt
          );
          this.itemdata.next_annuity_date = this.formatDate(
            this.data_maserter_pt.next_annuity_date_pt
          );
          this.itemdata.final_due_date_for_next_payment = this.formatDate(
            this.data_maserter_pt.final_due_date_for_next_payment_pt
          );
        }
        if (isRegistration) {
          this.showAnnReg = true;
          this.default_col = true;
        } else {
          this.showAnnfirst = true;
        }
      }

      if (isNewFiling) {
        this.itemdata.enddate = null;
        this.showNew = true;
        this.default_col = false;

        const sorted = [...this.data_maserter_pt_priority].sort(
          (a, b) => new Date(a.priority_date) - new Date(b.priority_date)
        );
        const oldest = sorted[0]?.priority_date;
        if (oldest) {
          const [y, m, d] = oldest.split("-").map(Number);
          const date = new Date(y, m - 1, d);

          if (this.data_maserter_pt.sub_type === "PARIS")
            date.setMonth(date.getMonth() + 12);
          if (this.data_maserter_pt.sub_type === "PCT")
            date.setMonth(date.getMonth() + 30);

          this.itemdata.new_filling = `${String(date.getDate()).padStart(
            2,
            "0"
          )}/${String(date.getMonth() + 1).padStart(
            2,
            "0"
          )}/${date.getFullYear()}`;
        }
        if (isNewFilingExact) {
          this.showNewFilingExact = true;
          this.itemdata.date_of_application = this.formatDate(
            this.data_maserter_pt.date_of_application
          );
          this.itemdata.app_no = this.data_maserter_pt.app_no;
          this.date_of_application = this.data_maserter_pt.date_of_application;
        } else if (isNewFilingSubDoc) {
          this.showNewFilingSubdoc = true;
          this.default_col = true;
          if (this.data_maserter_pt.date_of_application) {
            this.itemdata.receive_date = this.formatDate(
              this.data_maserter_pt.date_of_application
            );
            this.receive_date = this.data_maserter_pt.date_of_application;

            this.calDateFinalDeadline();
          } else {
            this.itemdata.receive_date = null;
          }
        } else {
          return;
        }
      }

      if (isChangeMaster) {
        this.showChage = true;
        this.default_col = false;
        this.default_type = false; // ✅ ตั้งค่า default_type ที่นี่เท่านั้น
      } else {
        this.default_type = true; // ✅ ถ้าไม่ใช่ Change Master ให้เป็น true
      }

      // No need to do anything for isSubstantiveExam – fields already cleared
      if (isSubstantiveExam) {
        this.showSub = true;
        if (this.data_maserter_pt.date_of_application) {
          this.itemdata.receive_date = this.formatDate(
            this.data_maserter_pt.date_of_publishing
          );
          this.receive_date = this.data_maserter_pt.date_of_publishing;

          this.itemdata.enddate = this.formatDate(
            this.data_maserter_pt.exam_request_deadline
          );
          this.enddate = this.data_maserter_pt.exam_request_deadline;

          this.enddate = this.data_maserter_pt.exam_request_deadline;

          if (this.enddate) {
            let d = new Date(this.enddate); // แปลง string → Date
            d.setDate(d.getDate() + 60); // บวก 60 วัน
            this.itemdata.internaldate = this.formatDate(
              d.toISOString().split("T")[0]
            ); // คืนค่าเป็น YYYY-MM-DD
            this.internaldate = d.toISOString().split("T")[0]; // คืนค่าเป็น YYYY-MM-DD
          } else {
            this.itemdata.internaldate = null;
          }

          // this.calDateFinalDeadline()
        } else {
          this.itemdata.receive_date = null;
        }
        // this.itemdata.receive_date = null;
        // this.itemdata.enddate = null;
        // this.itemdata.internaldate = null;
      } else {
        if (!isNewFiling && !isSubstantiveExam) {
          this.itemdata.receive_date = this.formatDate(
            new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
              .toISOString()
              .substr(0, 10)
          );
          this.calDateFinalDeadline();
        }
      }
      this.$forceUpdate();
    },
    calDateFinalDeadline() {
      if (this.itemdata.doctype != 0 && this.itemdata.doctype) {
        if (this.showSub) {
          const [year, month, day] = this.receive_date.split("-").map(Number);
          const date = new Date(year, month - 1, day);
          date.setFullYear(date.getFullYear() + 5);
          date.setDate(date.getDate() - 1);

          const y = date.getFullYear();
          const m = String(date.getMonth() + 1).padStart(2, "0");
          const d = String(date.getDate()).padStart(2, "0");
          this.itemdata.enddate = `${d}/${m}/${y}`;

          const internalDate = new Date(date);
          const originalDay = internalDate.getDate();
          internalDate.setMonth(internalDate.getMonth() - 6);
          if (internalDate.getDate() < originalDay) {
            internalDate.setDate(0);
          }

          const iy = internalDate.getFullYear();
          const im = String(internalDate.getMonth() + 1).padStart(2, "0");
          const id = String(internalDate.getDate()).padStart(2, "0");
          this.itemdata.internaldate = `${id}/${im}/${iy}`;
        } else {
          const dataItem = this.documenttype_ptlist.find(
            (item) => item.documenttype_id === this.itemdata.doctype
          );

          const dateplus = dataItem?.numberofenddate
            ? dataItem.numberofenddate - 1
            : 0;

          const [year, month, day] = this.receive_date.split("-").map(Number);
          const date = new Date(year, month - 1, day);
          date.setDate(date.getDate() + dateplus);

          const yyyy = date.getFullYear();
          const mm = String(date.getMonth() + 1).padStart(2, "0");
          const dd = String(date.getDate()).padStart(2, "0");
          this.itemdata.enddate = `${dd}/${mm}/${yyyy}`;

          const internalDate = new Date(date);
          internalDate.setDate(internalDate.getDate() - 7);

          const idd = String(internalDate.getDate()).padStart(2, "0");
          const imm = String(internalDate.getMonth() + 1).padStart(2, "0");
          const iyyyy = internalDate.getFullYear();
          this.itemdata.internaldate = `${idd}/${imm}/${iyyyy}`;
        }
      }
    },

    // async saveItem(mode) {
    // },

    async saveItem(mode) {
      var dataset = [];
      if (this.itemdata.objecttype == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check data ",
          "Put Object Type ",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.itemdata.doctype == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check data ",
          "Put PF Work Type ",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.itemdata.refno == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check data ",
          "Put File NO ",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (mode == "paymentrequest") {
        const checkMaterPT = await api.getfile_noPTPayment(this.itemdata.refno);
        if (checkMaterPT.data.length > 0) {
          dataset = checkMaterPT.data[0];

          if (!dataset.cus_billing_id || dataset.cus_billing_id == "") {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Check data ",
              "Please verify the customer's billing details.",
              "text-h5 red--text text-center"
            );
            return;
          }
        }
      }
      // if(
      //   !this.showAnn &&
      //   !this.showNew &&
      //   !this.showChage
      // ){
      //   if(!this.itemdata.filling_date){
      //           this.$store.state.global_dialog = true;
      //   this.setupAlertDialog(
      //     true,
      //     "Check data ",
      //     "Put File NO ",
      //     "text-h5 red--text text-center"
      //   );
      //   return;

      //   }
      // }
      // if (this.itemdata.doctype == 0) {
      //   this.$store.state.global_dialog = true;
      //   this.setupAlertDialog(
      //     true,
      //     "Check data ",
      //     "Put PF Work Type ",
      //     "text-h5 red--text text-center"
      //   );
      //   return;
      // }

      const exists = this.documenttype_ptlist_search.some(
        (item) => item.documenttype_id === this.itemdata.doctype
      );

      if (!exists) {
        this.itemdata.doctype = 0;
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check data ",
          "Put PF Work Type ",
          "text-h5 red--text text-center"
        );
        return;
      }

      // ป้องกัน undefined
      this.oldattfile = this.oldattfile ?? [];
      this.oldattimage = this.oldattimage ?? [];
      this.oldnotifile = this.oldnotifile ?? [];
      this.oldnotiimage = this.oldnotiimage ?? [];
      this.image_listattach = this.image_listattach ?? [];
      this.image_listnotice = this.image_listnotice ?? [];
      this.filenamenotice = this.filenamenotice ?? [];

      let datattF = [];
      let deleteattF = [];
      let dataattI = [];
      let deleteattI = [];

      for (const [index, item] of this.oldattfile.entries()) {
        if (this.image_listattach.some((file) => file.name === item.name)) {
          datattF.push(item.name);
        } else {
          deleteattF.push(item.name);
        }
      }

      for (const [index, item] of this.oldattimage.entries()) {
        if (this.image_listattach.some((file) => file.name === item.name)) {
          dataattI.push(item.name);
        } else {
          deleteattI.push(item.name);
        }
      }

      const dataoldattfile = datattF.join(",");
      const deleteoldattfile = deleteattF.join(",");
      const dataoldattimage = dataattI.join(",");
      const deleteoldattmage = deleteattI.join(",");

      let datanoticF = [];
      let deletedatanoticF = [];
      let datanoticI = [];
      let deletedatanoticI = [];

      for (const item of this.oldnotifile) {
        if (this.filenamenotice.includes(item)) {
          datanoticF.push(item);
        } else {
          deletedatanoticF.push(item);
        }
      }

      for (const item of this.oldnotiimage) {
        if (this.filenamenotice.includes(item)) {
          datanoticI.push(item);
        } else {
          deletedatanoticI.push(item);
        }
      }

      const dataoldnotifile = datanoticF.join(",");
      const deleteoldnotifile = deletedatanoticF.join(",");
      const dataoldnotiimage = datanoticI.join(",");
      const deleteoldnotiimage = deletedatanoticI.join(",");

      let datanotiall = "";
      const datachekcut = [...datanoticF, ...datanoticI];
      if (datachekcut.length > 0) {
        const datanotialllist = this.filenamenotice.filter(
          (item) => !datachekcut.includes(item)
        );
        datanotiall = datanotialllist.join(",");
      } else {
        datanotiall = this.filenamenotice.join(",");
      }

      // this.onSearchfile_nosave(this.itemdata.refno);

      // ตรวจสอบค่าบังคับ
      // if (!this.itemdata.refno?.trim()) {
      //   return this.showAlert("Put File NO");
      // }
      // if (!this.itemdata.objecttype) {
      //   return this.showAlert("Put Object Type");
      // }
      // if (!this.itemdata.doctype) {
      //   return this.showAlert("Put PF Work Type");
      // }
      // if (!this.itemdata.trademark_name?.trim()) {
      //   return this.showAlert("Put Client Name");
      // }

      const checkfile_noPT = await api.getfile_noPT(this.itemdata.refno);

      if (!checkfile_noPT.data[0]) {
        this.clearForm();
        this.setupAlertDialog(
          true,
          "Search File No.",
          "File No. not found",
          "text-h5 red--text text-center"
        );
        return;
      }

      let formData = new FormData();

      this.image_listnotice.forEach((item) => {
        if (item?.type) formData.append("file", item);
      });
      this.image_listattach.forEach((item) => {
        if (item?.type) formData.append("file", item);
      });

      formData.append("datanotiall", datanotiall);
      formData.append("datanotiold", dataoldnotifile);
      formData.append("dataoldnotiimage", dataoldnotiimage);
      formData.append("deleteoldnotifile", deleteoldnotifile);
      formData.append("deleteoldnotiimage", deleteoldnotiimage);
      formData.append("dataoldattfile", dataoldattfile);
      formData.append("dataoldattimage", dataoldattimage);
      formData.append("deleteoldattfile", deleteoldattfile);
      formData.append("deleteoldattmages", deleteoldattmage);
      formData.append("notice_file", "");
      formData.append("attachment_files", "");

      if (mode === "paymentrequest") this.itemdata.paymentrequest = 1;
      formData.append("paymentrequest", this.itemdata.paymentrequest);
      formData.append("objecttype", this.itemdata.objecttype);
      formData.append("doctype", this.itemdata.doctype);
      formData.append("sourcetype", this.itemdata.sourcetype);
      formData.append("trademark_name", ``);
      formData.append("owner_name", this.itemdata.trademark_name);
      formData.append("refno", this.itemdata.refno.trim());
      formData.append("categories", this.itemdata.categories.trim());
      formData.append("description", this.itemdata.description.trim());
      formData.append("remark", this.itemdata.remark);
      formData.append(
        "receive_date",
        this.changeformatDatetoinsert(this.itemdata.receive_date)
      );
      formData.append(
        "startdate",
        this.changeformatDatetoinsert(this.itemdata.startdate)
      );
      formData.append(
        "enddate",
        this.changeformatDatetoinsert(this.itemdata.enddate)
      );
      formData.append(
        "internaldate",
        this.changeformatDatetoinsert(this.itemdata.internaldate)
      );
      formData.append(
        `update_by`,
        Number(localStorage.getItem(server.USER_ID))
      );
      formData.append(`owner_contact`, this.itemdata.owner_contact);
      formData.append(`agent_contact`, this.itemdata.agent_contact);
      formData.append(`associate_contact`, this.itemdata.associate_contact);
      formData.append(
        `filling_date`,
        this.changeformatDatetoinsert(this.itemdata.filling_date)
      );

      // if(this.doctype_actions_select.length > 0){
      //   const data_doc_id = (this.doctype_actions_select?.map(item => item).join(",")) || "";
      //   formData.append("documenttype_action_id", data_doc_id);
      // }else{
      //   formData.append("documenttype_action_id","");
      // }
      formData.append("documenttype_action_id", "");
      formData.append("cert", this.itemdata.cert);
      formData.append("report", this.itemdata.report);
      formData.append("done", this.itemdata.done);
      formData.append("closed", this.itemdata.closed);

      formData.append("nextdeadlineninety", 0);
      formData.append("nextdeadlinesixty", 0);
      if (this.showSub) {
        formData.append("check_sub", true);
      } else {
        formData.append("check_sub", false);
      }
      if (this.showAnn) {
        formData.append(
          "dead_last_annuity_paid",
          this.itemdata.dead_last_annuity_paid || ""
        );
        formData.append(
          "last_annuity_paid",
          this.changeformatDatetoinsert(this.itemdata.last_annuity_paid) || ""
        );
        formData.append(
          "next_annuity_date",
          this.changeformatDatetoinsert(this.itemdata.next_annuity_date) || ""
        );
        formData.append(
          "final_due_date_for_next_payment",
          this.changeformatDatetoinsert(
            this.itemdata.final_due_date_for_next_payment
          ) || ""
        );
        formData.append("check_doc", true);

        if (this.showAnnReg) {
          formData.set(
            `filling_date`,
            this.changeformatDatetoinsert(this.itemdata.filling_date)
          );
          formData.set(
            `receive_date`,
            this.changeformatDatetoinsert(this.itemdata.receive_date)
          );
          formData.set(
            `startdate`,
            this.changeformatDatetoinsert(this.itemdata.startdate)
          );
          formData.set(
            `enddate`,
            this.changeformatDatetoinsert(this.itemdata.enddate)
          );
          formData.set(
            `internaldate`,
            this.changeformatDatetoinsert(this.itemdata.internaldate)
          );
        } else {
          formData.set("filling_date", null);
          formData.set("receive_date", null);
          formData.set("startdate", null);
          formData.set(
            "enddate",
            this.changeformatDatetoinsert(this.itemdata.next_annuity_date) ||
              null
          );
          formData.set("internaldate", null);
        }
      } else {
        formData.append("dead_last_annuity_paid", "");
        formData.append("last_annuity_paid", "");
        formData.append("next_annuity_date", "");
        formData.append("final_due_date_for_next_payment", "");
        formData.append("check_doc", false);
      }

      if (this.showNew) {
        formData.append(
          "new_filling",
          this.changeformatDatetoinsert(this.itemdata.new_filling) || ""
        );
        formData.set("filling_date", null);
        formData.set("receive_date", null);
        formData.set("startdate", null);

        if (this.showNewFilingExact) {
          formData.set("newfilingECheck", true);
          formData.set("app_no", this.itemdata.app_no);
          formData.set(
            "date_of_application",
            this.changeformatDatetoinsert(this.itemdata.date_of_application) ||
              null
          );
          formData.set(
            "enddate",
            this.changeformatDatetoinsert(this.itemdata.enddate) || null
          );
        } else {
          formData.set("date_of_application", null);
          formData.set("newfilingECheck", false);
          formData.set("app_no", "");

          formData.set(
            "filling_date",
            this.changeformatDatetoinsert(this.itemdata.filling_date) || null
          );
          formData.set(
            "receive_date",
            this.changeformatDatetoinsert(this.itemdata.receive_date) || null
          );
          formData.set(
            "startdate",
            this.changeformatDatetoinsert(this.itemdata.startdate) || null
          );
        }
      } else {
        formData.set("newfilingECheck", false);
        formData.set("app_no", "");
        formData.set("date_of_application", null);
      }

      this.$showLoader();
      const resultAppointment = await api.AppointmentUpdateV2(
        this.appointment_id,
        formData
      );

      if (
        resultAppointment.status === 200 ||
        resultAppointment.status === 201
      ) {
        if (this.doctype_actions_select.length > 0) {
          const newValues = this.doctype_actions_select;
          const oldValues = this.doctype_actions_select_old;

          // ค่าใหม่ที่เพิ่มมา
          const added = newValues.filter((x) => !oldValues.includes(x));

          // ค่าเก่าที่ถูกลบออกไป
          const removed = oldValues.filter((x) => !newValues.includes(x));

          for (const item of removed) {
            var dataDelete = {
              documenttype_action_id: Number(item),
              appointment_id: Number(this.$route.params.appointment_id),
              appointment_type: `Patent`,
            };
            console.log(dataDelete);
            await api.deleteAppointmentDoctypeActionsByID({
              params: dataDelete,
            });
          }
          for (const [index, item] of added.entries()) {
            var dataAdd = {
              documenttype_action_id: item,
              appointment_id: this.$route.params.appointment_id,
              appointment_type: `Patent`,
              documenttype_follow: 0,
            };
            await api.createAppointmentDoctypeActions(dataAdd);
          }
        } else {
          await api.deleteAppointmentDoctypeActions(
            this.$route.params.appointment_id
          );
        }

        var dataaddchangeMasterRecord = this.changeMasterRecord;
        dataaddchangeMasterRecord.appointment_id =
          this.$route.params.appointment_id;
        dataaddchangeMasterRecord.update_by = Number(
          localStorage.getItem(server.USER_ID)
        );
        await api.updateCHAGE_MASTER_RECORD(
          this.$route.params.appointment_id,
          dataaddchangeMasterRecord
        );

        ///receipt
        const newImages = this.image_listrecicpt.filter(
          (newItem) =>
            !this.image_listrecicpt_old.some(
              (oldItem) => oldItem.name === newItem.name
            )
        );
        const newImageNames =
          Array.isArray(this.image_listrecicpt) &&
          Array.isArray(this.image_listrecicpt_old)
            ? this.image_listrecicpt
                .filter(
                  (newItem) =>
                    !this.image_listrecicpt_old.some(
                      (oldItem) => oldItem.name === newItem.name
                    )
                )
                .map((item) => item.name)
                .join(",")
            : "";

        const deleteImageNames =
          Array.isArray(this.image_listrecicpt) &&
          Array.isArray(this.image_listrecicpt_old)
            ? this.image_listrecicpt_old
                .filter(
                  (oldItem) =>
                    !this.image_listrecicpt.some(
                      (newItem) => newItem.name === oldItem.name
                    )
                )
                .map((item) => item.name)
                .join(",")
            : "";

        let formDataRc = new FormData();

        newImages.forEach((item) => {
          formDataRc.append("file", item);
        });
        formDataRc.append("newImageNames", newImageNames);
        formDataRc.append("deleteImageNames", deleteImageNames);
        await api.updateRecieptfile(this.appointment_id, formDataRc);

        //soft

        let formDataSoft = new FormData();

        // === 1. เพิ่มไฟล์ใหม่ ===
        for (const [key, files] of Object.entries(this.uploadedFiles)) {
          if (Array.isArray(files)) {
            files.forEach((file) => formDataSoft.append("file", file)); // แนบไฟล์จริง
            formDataSoft.append(key, files.map((f) => f.name).join(",")); // แนบชื่อไฟล์
          } else if (files) {
            formDataSoft.append("file", files);
            formDataSoft.append(key, files.name);
          }
        }

        // === 2. หาไฟล์ที่ถูกลบ ===
        const getDeletedFilesGrouped = (oldFiles, existingFiles) => {
          const grouped = {};
          for (const key in oldFiles) {
            const oldList = Array.isArray(oldFiles[key]) ? oldFiles[key] : [];
            const existingList = Array.isArray(existingFiles[key])
              ? existingFiles[key].map((f) => f.name)
              : [];
            const removed = oldList.filter(
              (name) => !existingList.includes(name)
            );
            if (removed.length) {
              grouped[`del${key}`] = removed.join(","); // เช่น delForm001: "file1.docx,file2.docx"
            }
          }
          return grouped;
        };

        const deletedFilesGrouped = getDeletedFilesGrouped(
          this.oldFilesCheck,
          this.existingFiles
        );

        // === 3. แนบชื่อไฟล์ที่จะลบลง FormData ===
        for (const [key, value] of Object.entries(deletedFilesGrouped)) {
          formDataSoft.append(key, value);
        }

        // === 4. เรียก API ===
        await api.updateSoftfile(
          this.$route.params.appointment_id,
          formDataSoft
        );

        //end
        var dataAdd = {
          user_id: localStorage.getItem(server.USER_ID),
          log_in_out_id: localStorage.getItem(server.LOGIN_ID),
          action: "Update",
          table_name: "appointment",
          table_id: this.$route.params.appointment_id,
          date: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
        };

        await api.addTransectionLog(dataAdd);

        var dataEditLog = {
          last_update: moment()
            .tz("Asia/Bangkok")
            .format("YYYY-MM-DD HH:mm:ss"),
        };
        await api.updateLogInOutLog(
          localStorage.getItem(server.LOGIN_ID),
          dataEditLog
        );

        this.$hideLoader();
        if (mode == "paymentrequest") {
          var dataPush = {
            customer_name_master: dataset.cus_name,
            yourRef: "",
            ourRef: "",
            docketId: this.$route.params.appointment_id,
          };

          var custonerId = 0;
          custonerId = Number(dataset.cus_billing_id);
          const hasThai = /[\u0E00-\u0E7F]/;

          if (hasThai.test(dataset.cus_name)) {
            dataPush.yourRef = `เลขที่อ้างอิงของลูกค้า: ${dataset.client_ref}`;
            dataPush.ourRef = `เลขที่อ้างอิงของบริษัท: ${dataset.file_no}`;
          } else {
            dataPush.yourRef = `Your Ref: ${dataset.client_ref}`;
            dataPush.ourRef = `Our Ref: ${dataset.file_no}`;
          }
          if (dataset.client_ref.trim() == "") {
            dataPush.yourRef = "";
          }
          this.$router.push({
            path: `/new-free-invoice/0/invoice/D/${custonerId}/Docket`,
            query: dataPush,
          });
          return;
        } else {
          this.$hideLoader();
          this.$store.state.global_push_dialog = true;
          localStorage.setItem(server.MODELMENU, 6);
          this.setupAlertDialogPush(
            true,
            "save data",
            "save data success",
            "text-h5 green--text text-center",
            "/appointment-patent-list"
          );
        }
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "save data",
          "can't save data",
          "text-h5 red--text text-center"
        );
      }
    },

    // ฟังก์ชันเสริมเพื่อให้โค้ดหลักสะอาด
    methods: {
      showAlert(msg) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check data",
          msg,
          "text-h5 red--text text-center"
        );
      },
      async saveLog() {
        const now = moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss");

        await api.addTransectionLog({
          user_id: localStorage.getItem(server.USER_ID),
          log_in_out_id: localStorage.getItem(server.LOGIN_ID),
          action: "Update",
          table_name: "appointment",
          table_id: this.$route.params.appointment_id,
          date: now,
        });

        await api.updateLogInOutLog(localStorage.getItem(server.LOGIN_ID), {
          last_update: now,
        });
      },
      clearForm() {
        this.itemdata.objecttype = 0;
        this.itemdata.refno = "";
        this.app_noshow = "";
        this.titleshow = "";
        this.itemdata.trademark_name = "";
        this.typeshow = 0;
      },
    },

    changeformatDatetoinsert(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("/");
      return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}`;
    },
    async setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    async setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    async setupAlertDialogPushpaymentIM(
      status,
      title,
      message,
      text_color,
      link,
      querydata
    ) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
      this.querydata = querydata;
    },
  },
  beforeCreate() {
    this.$store.state.navMenu = true;
  },
  watch: {
    date_of_application(val) {
      this.itemdata.date_of_application = this.formatDate(
        this.date_of_application
      );
    },
    receive_date(val) {
      this.itemdata.receive_date = this.formatDate(this.receive_date);
    },
    filling_date(val) {
      this.itemdata.filling_date = this.formatDate(this.filling_date);
    },
    startdate(val) {
      this.itemdata.startdate = this.formatDate(this.startdate);
    },
    enddate(val) {
      this.itemdata.enddate = this.formatDate(this.enddate);
    },
    internaldate(val) {
      this.itemdata.internaldate = this.formatDate(this.internaldate);
    },
    new_filling(val) {
      this.itemdata.new_filling = this.formatDate(this.new_filling);
    },
    last_annuity_paid(val) {
      this.itemdata.last_annuity_paid = this.formatDate(this.last_annuity_paid);
    },
    next_annuity_date(val) {
      this.itemdata.next_annuity_date = this.formatDate(this.next_annuity_date);
    },
    final_due_date_for_next_payment(val) {
      this.itemdata.final_due_date_for_next_payment = this.formatDate(
        this.final_due_date_for_next_payment
      );
    },
  },
};
